<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow>
                <CCol>
                    <!-- Title page  -->
                    <h1 class="page__title justify-content">
                        {{ $t(titlePage) }}
                    </h1>
                </CCol>
                <CCol>
                    <ButtonCreate
                        :title="$t('Create group')"
                        @click="
                            $router.push({
                                name: 'Create delivery campaign group',
                            })
                        "
                    >
                        {{ $t("Create group") }}
                    </ButtonCreate>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.groups.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <div class="d-flex">
                                    <TableSettings
                                        :allFields="tables.groups.allFields"
                                        :activeFields.sync="
                                            tables.groups.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CCTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.groups.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.groups.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :columnFilterValue.sync="
                                        tables.groups.columnFilterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.groups.rows"
                                    v-bind="tables.groups"
                                    :resizable="false"
                                    size="sm"
                                >
                                    <template #active="{ item }">
                                        <CBadge
                                            v-if="stringToBoolean(item.active)"
                                            color="success"
                                            class="mr-2"
                                        >
                                            {{ $t("active") }}
                                        </CBadge>
                                        <CBadge
                                            v-else
                                            color="secondary"
                                            class="mr-2"
                                        >
                                            {{ $t("stop") }}
                                        </CBadge>
                                    </template>
                                    <template
                                        #return_priority_response="{ item }"
                                    >
                                        <span
                                            v-if="
                                                stringToBoolean(
                                                    item.return_priority_response
                                                )
                                            "
                                            class="mr-2"
                                        >
                                            {{ $t("yes") }}
                                        </span>
                                        <span v-else class="mr-2">
                                            {{ $t("no") }}
                                        </span>
                                    </template>
                                    <template #campaigns="{ item }">
                                        <span
                                            :key="index"
                                            v-for="(
                                                campaign, index
                                            ) in item.campaigns"
                                        >
                                            <RouterLink
                                                :to="
                                                    applyQueryToRoute({
                                                        route: '/app/campaings',
                                                        query: {
                                                            where: {
                                                                id: {
                                                                    equal: campaign.id,
                                                                },
                                                            },
                                                        },
                                                    })
                                                "
                                                >{{ campaign.name }}</RouterLink
                                            >{{
                                                index ==
                                                item.campaigns.length - 1
                                                    ? ""
                                                    : ", "
                                            }}
                                        </span>
                                    </template>
                                    <template
                                        #shipment_balancing_type="{ item }"
                                    >
                                        {{
                                            findBalancingShipmentTypeById(
                                                item.shipment_balancing_type
                                            )
                                        }}
                                    </template>
                                    <template #over-table>
                                        <CDropdown
                                            color="primary"
                                            :toggler-text="$t('actions')"
                                            class="m-2"
                                            :disabled="
                                                tables.groups.itemSelected ===
                                                null
                                            "
                                        >
                                            <CDropdownItem
                                                @click="
                                                    $router.push({
                                                        name: 'delivery_campaign_group_details',
                                                        params: {
                                                            uuid: tables.groups
                                                                .itemSelected
                                                                .uuid,
                                                        },
                                                    })
                                                "
                                            >
                                                {{ $t("Details") }}
                                            </CDropdownItem>
                                            <CDropdownItem
                                                @click="
                                                    $router.push({
                                                        name: 'Update delivery campaign group',
                                                        params: {
                                                            uuid: tables.groups
                                                                .itemSelected
                                                                .uuid,
                                                        },
                                                    })
                                                "
                                            >
                                                {{ $t("Edit group") }}
                                            </CDropdownItem>
                                            <CDropdownItem
                                                @click="
                                                    archiveGroup(
                                                        tables.groups
                                                            .itemSelected
                                                    )
                                                "
                                            >
                                                {{ $t("Archive group") }}
                                            </CDropdownItem>
                                        </CDropdown>
                                    </template>
                                    <template #_selected="{ index, item }">
                                        <CInputRadio
                                            name="_selected"
                                            :checked.sync="
                                                tables.groups.items[index]
                                                    ._selected
                                            "
                                            @update:checked="
                                                selectItemTable('groups', item)
                                            "
                                        />
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                endPoint="/shipment.balancing.api/client-groups/pagination"
                                                :table="tables.groups"
                                            />
                                        </div>
                                    </template>
                                </CCTable>
                            </CCardBody>
                            <CCardFooter v-if="tables.groups.total_pages > 0">
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.groups.page"
                                        :pages="tables.groups.total_pages"
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.groups.loading"
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/**
 * Components
 */
import CCTable from "~/components/CCTable";
import ButtonExport from "~/components/ButtonExport";
import ButtonBack from "£lement/ButtonBack";
import FilterDate from "~/components/FilterDate";
import TableSettings from "£lement/TableSettings";
import FilterFields from "~/components/FilterFields";
import ButtonCreate from "~/components/ButtonCreate";

/**
 * Mixins
 */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/**
 * Others
 */
import {
    cilPlus,
    cilSettings,
    cilPencil,
    cilTrash,
    cilArrowThickFromRight,
} from "@coreui/icons";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import DeliveryCampaignGroupsTableConfig from "./config/tables/DeliveryCampaignGroups.js";

export default {
    name: "DeliveryCampaignGroupsPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        TableSettings,
        ButtonBack,
        ButtonExport,
        FilterFields,
        ButtonCreate,
        CCTable,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
    },
    data() {
        return {
            tables: {
                groups: DeliveryCampaignGroupsTableConfig,
            },
        };
    },
    computed: {
        ...mapGetters({
            storeBalancingShipmentTypes: "global/balancingShipmentTypes",
        }),
    },
    watch: {
        storeBalancingShipmentTypes(newValue, oldValue) {
            let tableFieldBalancingShipmentTypes =
                this.tables.groups.fields.find((item) => {
                    return item.key == "shipment_balancing_type";
                });
            if (tableFieldBalancingShipmentTypes) {
                tableFieldBalancingShipmentTypes._filter.options = newValue.map(
                    (item) => {
                        return {
                            label: item.name,
                            value: item.id,
                        };
                    }
                );
            }
        },
    },
    methods: {
        async updateData() {
            this.tables.groups.itemSelected = null;
            await this.updateTable({
                tableName: "groups",
                url: `/shipment.balancing.api/client-groups/pagination`,
                customFields: {
                    _selected: false,
                },
            });

            this.tables.groups.allFields = this.getTableAllFields("groups");
            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },
        findBalancingShipmentTypeById(id) {
            let find = this.storeBalancingShipmentTypes.find((item) => {
                return item.id == id;
            });
            return find ? find.name : null;
        },
        async archiveGroup(item) {
            let result = await Swal.fire({
                title: this.$t("Are you sure?"),
                text: this.$t(
                    "Are you sure you want to archive this group of clients?"
                ),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: this.$t("Yes, archive it!"),
            });
            if (result.isConfirmed) {
                const response = await this.fetcher({
                    url: `/shipment.balancing.api/client-groups/${item.uuid}/archive`,
                    method: "PUT",
                });

                this.showMessageByMethod("PUT");
                await this.updateData();
            }
        },
    },
    mounted() {
        this.$store.dispatch("global/getBalancingShipmentTypes");
        this.updateData();
    },
};
</script>

<style scoped lang="scss"></style>
